import UserAPI from 'api/user';
import { setCurrentUser } from '../reducer';

const fetchCurrentUserThunk = () => (dispatch) => {
  return UserAPI.getCurrentUser().then((res) => dispatch(setCurrentUser(res.data)));
};

export default fetchCurrentUserThunk;
